<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Create Residential Status" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="create()" ngNativeValidate>
          <app-residential-status-form [residentialStatus]="residentialStatus" *ngIf="residentialStatus"></app-residential-status-form>
        </form>
      </div>
    </section>
  </div>
</div>


